import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    MOVEMENT_DIRECTION_DATE_DEFAULTS,
    MOVEMENT_DIRECTION_SECTION_DEFAULTS
} from "../../Model/Model";
import HandleChange from "../../../../../Helpers/HandleChange";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Handles the sections of a movement of a vehicle.
 *
 * The movement registers the vehicle and not the materials it carries, so the
 * form only holds the direction it takes and the values the guard completes at
 * the gate.
 */
const VehicleMovementSectionsApp = ({
    materialRequest,
    setMaterialRequest,
    setEmptyFieldsItems
}) => {
    const { t } = useTranslation();
    const { handleChange } = HandleChange({ model: materialRequest, setModel: setMaterialRequest });
    // The note that tells who completes the empty fields is dismissed by the user
    const [showGateMessage, setShowGateMessage] = useState(true);

    /**
     * Sets the movement direction of the form.
     *
     * When the direction changes, the section it enables and the date registered
     * at the gate are restored to their default values, so the information
     * captured for the previous direction is neither displayed nor submitted.
     *
     * @param {number} movementDirection - Selected movement direction.
     *
     * @returns {void}
     */
    const handleSelectMovementDirection = (movementDirection) => {
        if (materialRequest?.movementDirection === movementDirection)
            return;

        setEmptyFieldsItems(false);
        setMaterialRequest((prev) => ({
            ...prev,
            ...MOVEMENT_DIRECTION_SECTION_DEFAULTS,
            ...MOVEMENT_DIRECTION_DATE_DEFAULTS,
            movementDirection,
        }));
    };

    return {
        t,
        handleChange,
        handleSelectMovementDirection,
        showGateMessage,
        setShowGateMessage
    };
};

export default VehicleMovementSectionsApp;
